"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "spacer": [
        "0",
        "4px",
        "8px",
        "16px",
        "24px",
        "32px",
        "40px"
    ]
};
